import React from "react";
import { LanguageConstants } from "../constants/LanguageConstants";
import { useSelector } from "react-redux";
import logo from "../Assets/images/main-logo.svg";

function WelcomeMessage(props: any) {
  const profiledata = useSelector((state: any) => state?.ProfileState);

  const handleClose = () => {
    props?.setShow(false);
  };

  return (
    <div className="modal-content">
      <button
        type="button"
        onClick={handleClose}
        className="btn-close"
        data-bs-dismiss="modal"
        aria-label={LanguageConstants?.ARIA_CLOSE}
      >
        <i className="icon-close-square" />
      </button>
      <div className="modal-body pb-4 text-center">
        <img className="m-logo mb-4" src={logo} alt="" />
        <h5 className="auth-modal-ttl">{LanguageConstants?.NOTIFACTION_TITAL}</h5>
        <p className="auth-modal-small-txt mt-2">{LanguageConstants?.NOTIFACTION_FIRST_DESC}</p>
        <p className="auth-modal-small-txt mt-2">
          {LanguageConstants?.USERNAME} : {profiledata?.data?.data?.email}
        </p>
        <p className="auth-modal-small-txt mt-2">{LanguageConstants?.NOTIFACTION_THIRD}</p>
        <button type="button" className="round-btn w-100 mt-4" onClick={handleClose}>
          {LanguageConstants?.GOT_IT}
        </button>
      </div>
    </div>
  );
}

export default WelcomeMessage;
